// DS: C59M
/** A floating panel with links to share a deviation on social media */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import SocialShareButtons from '../../SocialShareButtons';
import LinkIcon from '@wix/da-ds/pkg/Icons/24x24/Link';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './MobileSharePopup.scss';
const MobileSharePopup = ({ url, title, biData, requestClose })=>{
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    return /*#__PURE__*/ React.createElement(DSModal, {
        isOpen: true,
        onRequestClose: requestClose,
        isFullscreen: false,
        className: s['modal']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, t('share.via')), /*#__PURE__*/ React.createElement(SocialShareButtons, {
        className: s['social-buttons'],
        buttonClassname: s['social-button'],
        shareButtonClassname: s['social-button-inner'],
        nameClassname: s['button-text'],
        url: url,
        title: title || url,
        buttons: [
            'facebook',
            'twitter',
            'tumblr'
        ],
        iconSize: 42,
        iconBgColor: "#0e0d20" // L8
        ,
        logoFillColor: "#00e59b" // G3
        ,
        biData: biData,
        showName: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['footer']
    }, /*#__PURE__*/ React.createElement(BiButton, {
        biData: BiData(_object_spread({
            evid: 357
        }, biData)),
        className: s['copy-button'],
        onClick: ()=>{
            copy(url);
            setCopied(true);
        }
    }, /*#__PURE__*/ React.createElement(LinkIcon, {
        size: IconSize.BIG
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['button-text']
    }, t(copied ? 'share.copied' : 'share.copyLink'))))));
};
MobileSharePopup.displayName = 'MobileSharePopup';
export default MobileSharePopup;

//# sourceMappingURL=MobileSharePopup.js.map